import { Tile } from "./TileDisplay";
import { WithTitle } from "./TileDisplay";

export function LatestValueChart({ tile, valueKeys }: { tile: Tile; valueKeys: string[] }) {

    const latestValue = tile.data.length > 0 ? tile.data[tile.data.length - 1] : undefined;

    return <>
        <WithTitle title={tile.title}>
            <div className="d-flex flex-column justify-content-center align-items-start h-100">
                {valueKeys.map(key => {
                    const v = latestValue != null ? latestValue[key] : null;
                    return <span key={key}>
                        <span className='mb-3'>Latest Value:</span>
                        <h3 style={{ fontWeight: 600 }} className='mb-5 mx-3'>
                            {v != null && +v ? `${+v} items` : "No Data"}
                        </h3>
                    </span>;
                })}
            </div>
        </WithTitle>
    </>
}